export const REGEX_NUMBER_N_DOT = /[^0-9.]/g;
export const REGEX_NUMBER = /^[0-9]*$/g;
export const CONTACT_NUMBER_REGEX = /^[+0-9][-\s0-9]*$/;
export const EMAIL_ADDRESS_REGEX = /^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$/;
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{12,20}$/;
export const PRICE_REGEX = /^\d*(\.\d{0,2})?$/;
export const USERNAME_REGEX = /^[a-zA-Z0-9._-]{6,20}$/;
export const NRIC_REGEX = /^[0-9]{12}$/;
export const NO_WHITESPACE_REGEX = /^\S*$/;
